﻿(function (w) {
    w.LBSApp = w.LBSApp || {};
    w.LBSApp.Components = w.LBSApp.Components || {};

    w.LBSApp.Components.BlogPostList = function (
        element, // The element that the component is attached to
        rootNodeId,
        pageSize,
        totalPages,
        category,
        canFetchMore,
        includeContent,
        layout,
        backUrl
    ) {
        const listItemsContainerEl = element.querySelector('.blog-post-list-items');
        const fetchMoreBtn = element.querySelector('.fetch-more-btn');
        let currentPage = 0;

        function init() {
            if (fetchMoreBtn) {
                fetchMoreBtn.addEventListener('click', getPosts);
            }
        }

        function getPosts() {
            fetchMoreBtn.disabled = true;
            fetchMoreBtn.classList.add('is-loading');
            currentPage = currentPage + 1;
            fetch('/umbraco/surface/BlogSurface/BlogPosts?rootNodeId=' + rootNodeId + '&category=' + category + '&page=' + currentPage + '&pageSize=' + pageSize + '&includeContent=' + includeContent + '&backUrl=' + backUrl + '&layout=' + layout)
                .then(res => res.text())
                .then(res => {
                    listItemsContainerEl.insertAdjacentHTML('beforeend', res)
                    console.log(res);
                    fetchMoreBtn.disabled = false
                    fetchMoreBtn.classList.remove('is-loading');
                    if (currentPage >= totalPages - 1) {
                        fetchMoreBtn.style.display = 'none';
                    }
                })
        }

        init();
    }
})(window);